// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import {
  initializeAuth,
  getAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: 'AIzaSyDI6zx73CcvfyzHKM9YRc5QPjehrJfaAWw',
  authDomain: 'iiee-ercsa-2026.firebaseapp.com',
  databaseURL: 'https://iiee-ercsa-2026-default-rtdb.firebaseio.com',
  projectId: 'iiee-ercsa-2026',
  storageBucket: 'iiee-ercsa-2026.firebasestorage.app',
  messagingSenderId: '275722314061',
  appId: '1:275722314061:web:47a3a895170e7c32759704',
  measurementId: 'G-Y9PEPHWFPD',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

// On native Android/iOS, use initializeAuth with IndexedDB persistence.
// On web, use getAuth (browser handles persistence automatically).
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, {
      persistence: indexedDBLocalPersistence,
    })
  : getAuth(app);